import _forOwn from "./forOwn";
var exports = {};
var forOwn = _forOwn;
/**
 * Get object keys
 */

var keys = Object.keys || function (obj) {
  var keys = [];
  forOwn(obj, function (val, key) {
    keys.push(key);
  });
  return keys;
};

exports = keys;
export default exports;